<template>
  <div>
    <el-dialog :visible.sync="isBusinessQuotation" width="96%" top="50px" @close='closeDialog' class="pub_dialog">
      <template v-slot:title>
        <ul class="drawer_title">
          <li>询价单: {{getInquiryNo}}</li>
        </ul>
      </template>
      <div class="drawerInformation">
        <!-- 基本信息 -->
        <div class="purchasingGoods">基本信息</div>
        <div style="display:flex;flex-wrap: wrap;">
          <el-form :inline="true" :model="formInline" class="demo-form-inline" style="width:100%;display:flex">
            <el-form-item style="width:33%;display:flex" label="竞　价　品　类：">
              <el-select v-model="formInline.brandTypeIds" placeholder="请选择" filterable @change="getbrandarr">
                <el-option
                  v-for="(item,index) in biddingCategory"
                  :key="index"
                  :label="item.Name"
                  :value="item.Id"/>
              </el-select>
            </el-form-item>
            <el-form-item style="width:33%;display:flex" label="竞　价　品　牌：">
              <el-select  v-model="formInline.brandIds" placeholder="请选择" filterable>
                <el-option
                  :label="item.Name"
                  :value="item.Id"
                  v-for="(item,index) in competitiveBrands"
                  :key="index"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <!-- 表格 -->
        <div class="purchasingGoods">报价商品</div>
        <el-table :data="tableData" stripe border>
          <!-- 可编辑table区域 -->
          <el-table-column prop="GoodsName" label="商品名称" align="center">
            <template slot-scope="scope">
                <el-input v-model="scope.row.GoodsName" placeholder="请输入商品名称" maxlength="20"/>
            </template>
          </el-table-column>
          <el-table-column prop="GoodsCode" label="商品型号" align="center">
            <template slot-scope="scope">
                <el-input v-model="scope.row.GoodsCode" placeholder="请输入商品型号" maxlength="20"/>
            </template>
          </el-table-column>
          <el-table-column prop="StyleId" label="风格" align="center">
            <template slot-scope="scope">
                <!-- <el-input v-model="scope.row.StyleId" placeholder="请输入风格"/> -->
                <el-select v-model="scope.row.StyleId" placeholder="请选择">
                  <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in tBDStyle" :key="index"/>
                </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="UnitId" label="单位" align="center">
            <template slot-scope="scope">
                <!-- <el-input v-model="scope.row.UnitId" placeholder="请输入单位"/> -->
                <el-select v-model="scope.row.UnitId" placeholder="请选择">
                  <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in tBDUnit" :key="index"/>
                </el-select>
            </template>
          </el-table-column>
          <el-table-column label="参考图片/图纸" align="center">
            <template slot-scope="scope">
              <span @click="endUploadPicture(scope.row)" style="color: #F56C6C">上传({{scope.row.Imgs ? scope.row.Imgs.length : 0}}/5)</span>
            </template>
          </el-table-column>
          <el-table-column prop="Counts" label="数量" align="center">
            <template slot-scope="scope">
                <el-input v-model="scope.row.Counts" placeholder="请输入数量" maxlength="5"
                oninput = "value=value.replace(/[^\d]/g,'')"
                type="text" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
            </template>
          </el-table-column>
          <el-table-column prop="UnitPrice" label="单价" align="center">
            <template slot-scope="scope">
                <el-input v-model="scope.row.UnitPrice" placeholder="请输入单价" maxlength="9"
                type="text" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
            </template>
          </el-table-column>
          <el-table-column prop="Remark" label="备注说明" align="center">
            <template slot-scope="scope">
                <el-input v-model="scope.row.Remark" placeholder="请输入备注" maxlength="50"/>
            </template>
          </el-table-column>

          <el-table-column label="操作" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="addLine" style="margin: 6px 3px;"
                v-if="scope.$index == tableData.length - 1"> 添加</el-button>
              <el-button size="mini" @click="handleDelete(scope.$index, scope.row)" style="margin: 6px 3px;"
                v-if="tableData.length > 1"> 删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="total">
          <span><strong>总计：</strong></span>
          <span><strong>{{hejishuliang}}</strong></span>
          <span><strong>{{hejidanjia}}</strong></span>
          <span><strong>{{zonghe}}</strong></span>
        </div>
        <div class="labelInput">
          <label>竞标价:　</label>
          <el-input type="Number" v-model="purchasingPrice" placeholder="请输入最终竞标价"
           style="width: 300px" maxlength="9"
           oninput="value=value.replace(/[^\d^\.]/g,'')"
           onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
          <label>　平台佣金: <strong>{{(pingtaiyongjin * 100).toFixed(2)}}%</strong></label>
          <label>　平台应得佣金: <strong>¥ {{zuizhongJbj}}</strong></label>
        </div>
        <!-- 报价要求 -->
        <div class="purchasingGoods">报价要求</div>
        <div style="display:flex;flex-wrap: wrap;">
          <el-form style="width:100%;display:flex;">
            <el-form-item style="display:flex" label="报价有效截止日期：">
              <el-date-picker type="date" v-model="EffectDate"
                @change="seedata()" style="width:200px" :editable = "false"
                value-format="yyyy-MM-dd" :picker-options="pickerStartDate" placeholder="选择有效截止日期"/>
            </el-form-item>
            <el-form-item style="display:flex;margin-left:30px" label="计划送货截止日期：">
              <span style="margin-right:10px;">付款</span>
              <el-input placeholder="请输入" v-model="DeliveryDate" style="width: 100px"
              oninput = "value=value.replace(/[^\d]/g,'')"/>
              <span style="margin-left:10px;">天后送货</span>
            </el-form-item>
          </el-form>
          <span style="width:100%;display:flex">
            <p style="white-space: nowrap;">备注：</p>
            <p style="width:80%;word-wrap: break-word;">
              <el-input type="textarea" :rows="8" placeholder="请输入其他事项以及其他收费款项标准" v-model="textarea" maxlength="150"/>
              <el-checkbox v-model="checked" style ="margin-top:10px"><a @click="contract()" href="javascript:;">报价协议</a></el-checkbox>
            </p>
          </span>
        </div>
        <div class="drawer_foot">
          <el-button @click="isBusinessQuotation = false">取消</el-button>
          <el-button type="danger" v-show="SubmitQuoteButton" :disabled="isDisable" @click="submitQuotation">提交报价</el-button>
          <el-button type="danger" v-show="ModifyQuoteButton" :disabled="isDisable" @click="cliModifyQuotation">修改报价单</el-button>
        </div>
      </div>
    </el-dialog>
    
    <!-- 上传图片功能-弹框 -->
    <el-dialog :visible.sync="isPicture" :show-close= false @close="closeUpload">
      <template v-slot:title>
        <ul class="drawer_title">
          <li>上传{{flag}}张图片</li>
          <li>
            <el-button type="danger" @click="closeUpload" style="margin-top: -10px;">关 闭</el-button>
          </li>
        </ul>
      </template>
      <div class="drawerPicdiv">
        <div class="upPictures">
          <div class="block" style="width:80px;height:80px;float:left;margin-right:10px;"
            v-for="(item,index) in detailImgUrlarr"
            :key="index"
            :data-img="item">
            <div style="float:left;margin-right:10px;margin-top:5px" class="tuimg">
              <el-image style="width: 80px; height:80px" :src="item"/>
              <div class="chahao" @click.stop="deldetail(index)">
                <img src="../../assets/img/aicon36.png" alt />
              </div>
            </div>
          </div>
          <!-- 上传图片 -->
          <el-upload action multiple list-type="picture-card" v-if="flag < 5"
            :before-upload="beforeAvatarUpload" accept=".png, .jpg,.jpeg">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="clear: both"></div>
        </div>
        <!-- 弹框 取消按钮 -->
        <div class="preservation_div">
          <el-button @click="closeUpload">取消</el-button>
          <el-button type="danger" @click="endConfirmUpload">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { UploadImgForServer,SelectBrandTypeBaseDataByCondition } from '../../api/newOss';
import { getSubmitQuotation, getUpdateQuotation, getkind,getSelectQuotationByInquiryIdAndUserId,
SelectGoodsBrandByBrandType, getSelectCommisionRateByUserIDAndBrandId } from "../../api/api";
  export default {
    name: "BusinessQuotation",
    props: ['inquiryId', 'inquiryNo', 'formDetails'],
    data () {
      return {
        isBusinessQuotation: false, // 商家报价弹框
        isDisable:false,
        SubmitQuoteButton: true, // 提交报价按钮
        ModifyQuoteButton: false, // 修改报价单按钮
        getInquiryId: '', // 询价单ID
        getInquiryNo: '', // 询价单
        quotationId: '', // 报价单ID
        xunjiahao: '',
        checked: true, // 报价协议
        isPicture: false, // 上传图片弹框
        id: '',
        flag: 0,
        detailImgUrlarr: [],
        pickerStartDate: {
          disabledDate(time) {
            return time.getTime()>365 * 24 * 3600 * 1000+ new Date().getTime()||  time.getTime() < Date.now()-24 * 3600 * 1000
          },
        },
        biddingCategory: [], // 竞价品类
        competitiveBrands: [], // 竞价品牌
        formInline: {
          brandTypeIds: 0,
          brandIds: 0
        },
        tBDStyle: [], // 风格
        tBDUnit: [], // 单位
        tableData:[{
          GoodsName: '', // 商品名称
          GoodsCode:'', // 商品型号
          StyleId: 0, // 风格
          UnitId: 0, // 单位
          Counts: '', // 数量
          UnitPrice: '', // 单价
          Remark: '', // 备注
          Imgs: []
        }],
        purchasingPrice: "", // 竞标价
        pingtaiyongjin: '', // 平台佣金
        // zuizhongJbj: '', // 最终竞标价
        EffectDate: "",
        DeliveryDate:"",
        textarea: '', // 备注
        param: ''
      }
    },
    methods: {
      // 初始化
      init () {
        this.getInquiryId = this.inquiryId;
        this.getInquiryNo = this.inquiryNo;
        this.formInline.brandTypeIds = 0;
        this.formInline.brandIds = 0;
        this.competitiveBrands = [{
          Id: 0,
          Name: "请选择"
        }];
        // 如果有报价列表-就回显
        if (this.formDetails) {
          this.quotationId = this.formDetails.Id;
          this.formInline.brandTypeIds = this.formDetails.BrandTypeId;
          this.formInline.brandIds = this.formDetails.BrandId;
          this.tableData = this.formDetails.QuotationGoods;
          this.purchasingPrice = this.formDetails.BidPrice; // 竞标价
          this.pingtaiyongjin = this.formDetails.Commission; // 平台佣金
          // this.zuizhongJbj = this.formDetails.TotalbidPrice; // 最终竞标价
          this.EffectDate = this.formDetails.QuoteEffectiveDate; // 报名有效截止日
          this.DeliveryDate = this.formDetails.DeliveryDaysAfterPay; // 送货日期
          this.textarea = this.formDetails.QuoteRemark; // 备注
          this.SubmitQuoteButton = false;
          this.ModifyQuoteButton = true;
        }
        this.isBusinessQuotation = true;
      },
      //关闭弹框的事件
      closeDialog(){
        //清空数据
        this.tableData =[{
          GoodsName: '', // 商品名称
          GoodsCode:'', // 商品型号
          StyleId: 0, // 风格
          UnitId: 0, // 单位
          Counts: '', // 数量
          UnitPrice: '', // 单价
          Remark: '', // 备注
          Imgs: []
        }],
        this.detailImgUrlarr = [],
        this.purchasingPrice = "", // 竞标价
        this.pingtaiyongjin = '', // 平台佣金
        this.EffectDate = "",
        this.DeliveryDate = "",
        this.textarea = '' // 备注
      },
      // 点击上传图片
      endUploadPicture (row) {
        this.detailImgUrlarr = row.Imgs;
        this.flag = row.Imgs.length;
        row.upload = true;
        this.isPicture = true;
      },
      // 提交报价
      submitQuotation() {
        this.isDisable = true;
        this.isDisable = false;
        if(this.formInline.brandTypeIds == ""){
        this.$swal({
            type:'warning',
            text: '请选择竞价品类 !',
          })
          return false
        }
        if(this.formInline.brandIds == ""){
          this.$swal({
            type:'warning',
            text: '请选择竞价品牌 !',
          })
          return false
        }
        for(var i = 0; i < this.tableData.length; i++) {
          if(this.tableData[i].GoodsName == ""){
            this.$swal({
              type:'warning',
              text: '请输入商品名称 !',
            })
            return false
          }
          if(this.tableData[i].GoodsCode == ""){
            this.$swal({
              type:'warning',
              text: '请输入商品型号 !',
            })
            return false
          }
          if(this.tableData[i].UnitId == ""){
            this.$swal({
              type:'warning',
              text: '请选择单位 !',
            })
            return false
          }
          if(this.tableData[i].Imgs.length == 0){
            this.$swal({
              type:'warning',
              text: '请上传参考图片 !',
            })
            return false
          }
          if(this.tableData[i].Counts == ""){
            this.$swal({
              type:'warning',
              text: '请输入数量 !',
            })
            return false
          }
          if(this.tableData[i].UnitPrice == ""){
            this.$swal({
              type:'warning',
              text: '请输入单价 !',
            })
            return false
          }
        }
        if(this.purchasingPrice == ""){
          this.$swal({
            type:'warning',
            text: '请输入竞标价 !',
          })
          return false
        }
        if(this.EffectDate == ""||this.EffectDate+""== "null"){
          this.$swal({
            type:'warning',
            text:"请选择报价截止日"
          })
          return false
        }
        if(this.DeliveryDate == ""){
          this.$swal({
            type:'warning',
            text: '请输入送货日期 !',
          })
          return false
        }
        // 深度拷贝 - 上传图片的Url去掉协议头
        let tableData = JSON.parse(JSON.stringify(this.tableData));
        for(var i = 0; i < tableData.length; i++) {
          tableData[i].Imgs = tableData[i].Imgs.map(item => {
            return item.replace(localStorage.BaseUrl, '')
          })
        }
        var obj = {
          "UserId": localStorage.Id, // 当前操作人
          "InquiryId": this.getInquiryId, // 询价单ID
          "BrandTypeId": this.formInline.brandTypeIds, // 品类ID
          "BrandId": this.formInline.brandIds, // 品牌ID
          "BidPrice": this.purchasingPrice, // 竞标价
          "QuoteEffectiveDate": this.EffectDate+" "+"23:59:59", // 报价有效截止日
          "DeliveryDaysAfterPay": parseInt(this.DeliveryDate), // 计划送货日期
          "Remark": this.textarea, // 备注
          "SubmitQuotationGoodsModels": tableData
        };
        var headers = {
          headers: {
            "Content-Type": "application/json;"
          }
        }
        getSubmitQuotation(obj, headers).then(data => {
          if (data.ResultCode == 1) {
            this.$swal({
              text:"提交报价成功",
              type: "success"
            })
            this.isBusinessQuotation = false;
            this.$emit('closeSee');
          }
        });
      },
      // 提交-修改报价单
      cliModifyQuotation() {
        this.isDisable = true;
        this.isDisable = false;
        if(this.formInline.brandTypeIds == ""){
        this.$swal({
            type:'warning',
            text: '请选择竞价品类 !',
          })
          return false
        }
        if(this.formInline.brandIds == ""){
          this.$swal({
            type:'warning',
            text: '请选择竞价品牌 !',
          })
          return false
        }
        for(var i = 0; i < this.tableData.length; i++) {
          if(this.tableData[i].GoodsName == ""){
            this.$swal({
              type:'warning',
              text: '请输入商品名称 !',
            })
            return false
          }
          if(this.tableData[i].GoodsCode == ""){
            this.$swal({
              type:'warning',
              text: '请输入商品型号 !',
            })
            return false
          }
          if(this.tableData[i].UnitId == ""){
            this.$swal({
              type:'warning',
              text: '请选择单位 !',
            })
            return false
          }
          if(this.tableData[i].Imgs.length == 0){
            this.$swal({
              type:'warning',
              text: '请上传参考图片 !',
            })
            return false
          }
          if(this.tableData[i].Counts == ""){
            this.$swal({
              type:'warning',
              text: '请输入数量 !',
            })
            return false
          }
          if(this.tableData[i].UnitPrice == ""){
            this.$swal({
              type:'warning',
              text: '请输入单价 !',
            })
            return false
          }
        }
        if(this.purchasingPrice == ""){
          this.$swal({
            type:'warning',
            text: '请输入竞标价 !',
          })
          return false
        }
        if(this.EffectDate == ""||this.EffectDate+""== "null"){
          this.$swal({
            type:'warning',
            text:"请选择报价截止日"
          })
          return false
        }
        if(this.DeliveryDate == ""){
          this.$swal({
            type:'warning',
            text: '请输入送货日期 !',
          })
          return false
        }
        // 深度拷贝 - 上传图片的Url去掉协议头
        let tableData = JSON.parse(JSON.stringify(this.tableData));
        for(var i = 0; i < tableData.length; i++) {
          tableData[i].Imgs = tableData[i].Imgs.map(item => {
            return item.replace(localStorage.BaseUrl, '')
          })
        }
        var obj = {
          "QuotationId": this.quotationId, // 报价单ID
          "UserId": localStorage.Id, // 当前操作人
          "InquiryId": this.getInquiryId, // 询价单ID
          "BrandTypeId": this.formInline.brandTypeIds, // 品类ID
          "BrandId": this.formInline.brandIds, // 品牌ID
          "BidPrice": this.purchasingPrice, // 竞标价
          "QuoteEffectiveDate": this.EffectDate+" "+"23:59:59", // 报价有效截止日
          "DeliveryDaysAfterPay": parseInt(this.DeliveryDate), // 计划送货日期
          "Remark": this.textarea, // 备注
          "UpdateQuotationGoodsModels": tableData
        };
        var headers = {
          headers: {
            "Content-Type": "application/json;"
          }
        }
        // 调用修改报价单接口
        getUpdateQuotation(obj, headers).then(data => {
          if (data.ResultCode == 1) {
            this.$swal({
              text:"修改报价成功",
              type: "success"
            })
            this.isBusinessQuotation = false;
            this.callQuotationRecord();
          }
        });
      },
      // 调用报价记录接口
      callQuotationRecord () {
        var addParams = {
          userId: localStorage.Id, // 当前登陆人ID
          inquiryId: this.getInquiryId // 询价单ID
        };
        getSelectQuotationByInquiryIdAndUserId(addParams).then(data => {
          this.param = data.ResultObj;
          this.$emit('add-comment', this.param);
        })
      },
      // 添加行数
      addLine(){
        let newValue = {
          GoodsName: '', // 商品名称
          GoodsCode:'', // 商品型号
          StyleId: 0, // 风格
          UnitId: 0, // 单位
          Counts: '', // 数量
          UnitPrice: '', // 单价
          Remark: '', // 备注
          Imgs: []
        };
        //添加新的行数
        this.tableData.push(newValue);
      },
      //删除行数
      handleDelete(index){
        this.tableData.splice(index, 1);
      },
      seedata() {
        if(new Date(this.DeliveryDate)<new Date(this.EffectDate)){
          this.DeliveryDate = ""
        }
      },
      // 报价协议
      contract(){
        window.open(localStorage.BaseUrl+"/Resource/AgreementsForBidding/merchantsAgreementRules.pdf")
      },
      // 上传图片
      beforeAvatarUpload(file) {
        // 判断图片格式
        const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
        // 判断图片大小
        const isLt2M = file.size / 1024 / 1024 <= 1;
        if (!isJPG) {
          this.$swal({
            type: "warning",
            text: "上传图片只支持jpg、png等格式!"
          });
          return;
        }
        if (!isLt2M) {
          this.$swal({
            type: "warning",
            text: "上传图片大小不能超过 1MB!"
          });
          return;
        }
        var _this = this;
        this.flag += 1;
        if (this.flag > 5) {
          this.$swal({
            type: "warning",
            text: "最多传入5张图片"
          });
          return false;
        }
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function(e) {
            var obj ={
            base64Img:e.target.result,
            uploadType: 9
          }
          // 上传图片接口
          UploadImgForServer(obj).then(data=>{
            if(data.ResultCode == 1){
              _this.detailImgUrlarr.push(localStorage.BaseUrl+data.ResultObj);
            }
          })
        };
        return file;
      },
      //删除上传图片
      deldetail(val) {
        let newdetailImgUrlarr = this.detailImgUrlarr;
        for (var i = 0; i < newdetailImgUrlarr.length; i++) {
          if (val == i) {
            newdetailImgUrlarr.splice(i, 1);
          }
        }
        this.detailImgUrlarr = newdetailImgUrlarr;
        this.flag = this.detailImgUrlarr.length;
      },
      // 确认上传图片按钮
      endConfirmUpload() {
        if(this.detailImgUrlarr.length > 0) {
          let imgUrls = this.detailImgUrlarr.join(","); // 以英文逗号分隔
          let the = this.tableData.find(item => item.upload);
          the.Imgs = imgUrls.split(",");
          the.upload = false;
          // item.Imgs = imgUrls.split(",");
        }
        this.isPicture = false;
      },
      // 关闭上传图片弹框
      closeUpload() {
        let the = this.tableData.find(item => item.upload);
        if(the) {
          the.upload = false;
        }
        this.isPicture = false;
        clearTimeout(this.timer);
      },
      // 获取风格
      gettBDStyle() {
        let that = this;
        var loginParams = {
          tablename: "tBD柜_风格"
        };
        getkind(loginParams).then(data => {
          data = data.ResultObj;
          var obj = {
            Id: 0,
            Name: "请选择"
          };
          data.unshift(obj);
          that.tBDStyle = data;
        })
      },
      // 获取单位
      gettBDUnit() {
        let that = this;
        var loginParams = {
          tableName: "tBDUnit"
        };
        getkind(loginParams).then(data => {
          data = data.ResultObj;
          var obj = {
            Id: 0,
            Name: "请选择"
          };
          data.unshift(obj);
          that.tBDUnit = data;
        })
      },
      // 竞价品类
      getBrandType() {
        var obj = {
          userId: localStorage.Id
        };
        SelectBrandTypeBaseDataByCondition(obj).then(data => {
          if (data.ResultCode == 1) {
            this.biddingCategory = data.ResultObj;
            this.biddingCategory.unshift({
              Id: 0,
              Name: "请选择"
            });
          }
        });
      },
      // 竞价品牌
      getbrandarr() {
        this.formInline.brandIds = 0;
        var obj = {
          userId: localStorage.Id,
          brandTypeId: this.formInline.brandTypeIds
        };
        SelectGoodsBrandByBrandType(obj).then(data => {
          if (data.ResultCode == 1) {
            this.competitiveBrands = data.ResultObj;
            this.competitiveBrands.unshift({
              Id: 0,
              Name: "请选择"
            });
          }
        });
      },
    },
    mounted() {
      this.getBrandType();
      // this.getbrandarr();
      this.gettBDStyle(); // 风格
      this.gettBDUnit(); // 单位
    },
    computed: {
      // 合计数量
      hejishuliang() {
        let zongshu = 0;
        this.tableData.map(item => {
          zongshu += Number(item.Counts);
        })
        return zongshu;
      },
      // 合计单价
      hejidanjia() {
        let zongji = 0;
        this.tableData.map(item => {
          zongji += Number(item.UnitPrice);
        })
        if (isNaN(zongji)) {
          return 0;
        }
        return zongji.toFixed(2);
      },
      zonghe() {
        let zong = 0;
        this.tableData.map(item => {
          zong += Number(item.UnitPrice) * Number(item.Counts);
        })
        if (isNaN(zong)) {
          return 0;
        }
        return zong.toFixed(2);
      },
      zuizhongJbj() {
        let zhi = this.purchasingPrice * this.pingtaiyongjin;
        if(isNaN(zhi)) {
          return 0;
        }
        return zhi.toFixed(2);
      }
      // zuizhongJbj() {
      //   let zhi = this.purchasingPrice * (this.pingtaiyongjin + 1);
      //   if(isNaN(zhi)) {
      //     return 0;
      //   }
      //   return zhi.toFixed(2);
      // }
    },
    watch: {
      'formInline.brandTypeIds'(newV,oldV) {
        if(this.formInline.brandTypeIds != 0) {
          this.getbrandarr();
        }
      },
      'formInline.brandIds'(nv,ov) {
        // 调用平台佣金比例接口
        var obj = {
          userId: localStorage.Id,
          brandId: this.formInline.brandIds,
          iqId: this.getInquiryId
        };
        if(obj.brandId) {
          getSelectCommisionRateByUserIDAndBrandId(obj).then(data => {
            this.pingtaiyongjin = data.ResultObj;
          })
        }
      }
    }
  }
</script>
<style scoped>
.el-form-item {
  margin-bottom: 0;
}
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}
.drawer_title>li:first-child{
  font-size: 17px;
  font-weight: bolder;
  color: #333;
}
/* 商家报价 */
.pub_dialog {
  z-index: 999 !important;
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}
.drawerInformation {
  width: 96%;
  height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
  margin: 0 auto;
}
.purchasingGoods {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  color: #333;
  margin: 10px 0;
}
.labelInput {
  width: 100%;
  padding-top: 10px;
  margin: 0 auto;
}
.drawer_foot {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 10px;
}
/* 上传图片整体宽度 */
.drawerPicdiv {
  width: 100%;
  margin: 0 auto;
}
.upPictures {
  width: 100%;
  margin-bottom: 20px;
}
/* 按钮区域 */
.preservation_div {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.chahao {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  /* background: #ddd; */
  text-align: center;
  line-height: 25px;
  color: #666;
  position: absolute;
  right: -2px;
  top: -2px;
}
.chahao img {
  width: 100%;
  height: 100%;
  display: block;
}
.total {
  width: 100%;
  height: 36px;
  line-height: 36px;
  border-bottom: 1px solid #eee;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
}
.total>span:first-child {
  width: 55.5%;
  display: inline-block;
  text-align: right;
  border-right: 1px solid #eee;
}
.total>span {
  width: 10.8%;
  text-align: center;
  display: inline-block;
  border-right: 1px solid #eee;
}
</style>


// WEBPACK FOOTER //
// BusinessQuotation.vue?9f9e9ce8